<template>
  <BreadCrumb PageTitle="Nouveau Colis (Stock)" />
  <AddColis />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddColis from "../../components/Stock/AddColis.vue";

export default defineComponent({
  name: "AddColisPage",
  components: {
    BreadCrumb,
    AddColis,
  },
});
</script>